import { useState } from 'react'
import type { TIconProps } from '~/components/icon'
import { RADIO_STATE_MAPPER, type TRadioSizes } from '../types'

export const useRadioVariants = () => {
  const [pressed, setPressed] = useState(false)

  const iconSizeMapping: Record<TRadioSizes, TIconProps['size']> = {
    md: 'tiny',
    ml: 'small',
    lg: 'medium',
    xl: 'medium',
  }

  const renderCurrentStateRadio = (isChecked: boolean) => {
    if (isChecked) {
      return RADIO_STATE_MAPPER.CHECKED
    }
    return RADIO_STATE_MAPPER.UNCHECKED
  }

  return {
    renderCurrentStateRadio,
    iconSizeMapping,
    pressed,
    setPressed,
  }
}
